import Vue from 'vue'
import axios from 'axios'
import cfg from '@/cfg'

const API_URL = cfg.ACCOUNTS_API_URL

axios.defaults.withCredentials = true;

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = API_URL

// POST with JSON content type
axios.defaults.headers.post['Content-Type'] = 'application/json'

// It gives you easy global access to it instead use import
Vue.prototype.$http = axios.create()

const getDefaultState = () => {
  return {
    user: null,
    hasDefaultPaymentMethod: false,
    isAuthenticated: null
  }
}

// initial state
const state = getDefaultState()

export const getters = {
  isAuthenticated: state => state.isAuthenticated,
  hasDefaultPaymentMethod: state => state.hasDefaultPaymentMethod,
  user: state => state.user
}

export const actions = {
  ResetUserState(context) {
    context.commit('RESET_USER_STATE')
  },
  SetUser(context, user) {
    context.commit('SET_USER', user)
    context.commit('SET_AUTH', true)
  },
  CheckSession(context) {
    axios
      .get(cfg.ACCOUNTS_API_URL + "users")
      .then((response) => {
        context.commit('SET_USER', response.data)
        context.commit('SET_AUTH', true)
      })
      .catch(() => {
        context.commit('SET_USER', null)
        context.commit('SET_AUTH', false)
      });
  },
  CheckDefaultPaymentMethod: state => {
    axios
      .get(cfg.ACCOUNTS_API_URL + 's/customers/check-default-payment-method')
      .then((response) => {
        if (response.data == "ok"){
          state.commit('SET_DEFAULT_PAYMENT_METHOD', true)
        } else if (response.data == null) (
          state.commit('SET_DEFAULT_PAYMENT_METHOD', false)
        )
      })
      .catch((err) => {
        console.error(err)
        state.commit('SET_DEFAULT_PAYMENT_METHOD', false)
      });
  },
  Logout(context) {
    return new Promise((resolve, reject) => {
        Vue.prototype.$http.get('/logout')
        .then(() => {
          context.commit('SET_USER', null)
          context.commit('SET_AUTH', false)
          resolve()
        })
        .catch((error) => {
          context.commit('SET_USER', null)
          context.commit('SET_AUTH', false)
          reject(error.response.data.errors)
        })
    })
  },
}

export const mutations = {
  SET_USER(state, user) {
    state.user = user
    if (user != null) {
      state.user.lastPswUpdate = new Date( Date.parse(user.PasswordLastUpdateDateTime) ).toLocaleDateString();
      user.Initials = user.First.charAt(0) + user.Last.charAt(0);
    }
  },
  SET_AUTH(state, auth) {
    state.isAuthenticated = auth
  },
  RESET_USER_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_DEFAULT_PAYMENT_METHOD (state, status) {
    state.hasDefaultPaymentMethod = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
